import { NavLink } from "react-router-dom";
import { FiEye, FiTrash2 } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { connect } from "react-redux";
import { deleteReview } from "../../stores/actions/review.actions.types";
import { useState } from "react";
import Delete from "../Modals/delete";

const ReviewTable = ({ deleteReview, reviews, setReviews }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [reviewId, setReviewId] = useState(null);
  const handleDelete = async () => {
    setDeleteLoading(true);
    const callback = (data) => {
      if (data.success) {
        setReviews((prevReview) =>
          prevReview.filter((review) => review._id !== reviewId)
        );
        setDeleteLoading(false);
        setIsModalOpen(false);
      } else {
        setDeleteLoading(false);
      }
    };
    let request = {
      id: reviewId,
      callback,
    };
    deleteReview(request);
  };

  const handleDeleteClick = (id) => {
    setReviewId(id);
    setIsModalOpen(true);
  };

  return (
    <div className='rounded-[10px] drop-shadow-1 border-l border-slate-300 dark:border-slate-700 dark:bg-boxdark dark:drop-shadow-none border bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-gray-dark dark:shadow-card sm:p-2.5 transition-colors duration-300'>
      <div className='max-w-full overflow-x-auto overflow-y-hidden pb-2'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left dark:bg-dark-2 transition-colors duration-300'>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white xl:pl-7.5'>
                Product Name
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Review
              </th>
              <th className='min-w-[120px] px-4 py-2 font-medium text-dark dark:text-white'>
                Rating
              </th>
              <th className='min-w-[120px] px-4 py-2 font-medium text-dark dark:text-white'>
                Status
              </th>
              <th className='min-w-[150px] px-4 py-2  font-medium text-dark dark:text-white'>
                Created At
              </th>
              <th className='min-w-[150px] px-4 py-2  font-medium text-dark dark:text-white'>
                Updated At
              </th>
              <th className='min-w-[120px] px-4 py-2  font-medium text-dark dark:text-white xl:pr-7.5'>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {reviews?.map((review, index) => (
              <tr key={review?._id} className='text-sm'>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pl-7.5 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {review?.productId?.title}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {review?.comment}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {review?.rating}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5
                    className={`text-dark rounded-full px-2 text-center text-sm capitalize text-white  ${
                      review?.status === "approved"
                        ? " bg-green-600"
                        : "bg-red-600"
                    }`}
                  >
                    {review?.status}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {new Date(review?.createdAt).toLocaleDateString()}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <h5 className='text-dark dark:text-white'>
                    {new Date(review?.updatedAt).toLocaleDateString()}
                  </h5>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === reviews?.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <div className='flex items-center justify-end space-x-3.5'>
                    {/* Details button */}
                    <div className='group relative'>
                      <NavLink to={`/review/details/${review?._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEye className='text-lg' />
                        </button>
                      </NavLink>

                      <span className='absolute left-1/2 top-full w-[80px] -translate-x-1/2 transform rounded  bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity  duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white'>
                        Details
                      </span>
                    </div>
                    {/* Update button */}
                    <div className='group relative'>
                      <NavLink to={`/review/update/${review?._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEdit />
                        </button>
                      </NavLink>

                      <span className='absolute left-1/2 top-full w-[55px] -translate-x-1/2 transform rounded  bg-gray-7 px-2 py-1 text-xs text-white opacity-0 transition-opacity  duration-500 group-hover:opacity-100 dark:bg-white dark:text-gray-700'>
                        Update
                      </span>
                    </div>
                    <button
                      className=' hover:text-primary group relative'
                      onClick={() => handleDeleteClick(review._id)}
                    >
                      <FiTrash2 className='text-lg' />
                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded bg-gray-700 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100 dark:bg-white dark:text-gray-900'>
                        Delete
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Delete
        opened={isModalOpen}
        setOpend={setIsModalOpen}
        title='Review Delete'
        handleDelete={handleDelete}
        loading={deleteLoading}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });
export default connect(mapStateToProps, { deleteReview })(ReviewTable);
